export default {
  state: {
    firebaseBindingsRun: false,
    trustCenterData: '',
    trustCenterGeneralSettings: {},
    trustCenterDb: [],
    trustCenterSharesDb: [],
    subscriptions: [],
    updateId: null,
  },
  mutations: {
    SET_FIREBASE_BINDINGS_RUN(state, payload) {
      console.log('Inside SET_FIREBASE_BINDINGS_RUN', payload)
      state.firebaseBindingsRun = payload
    },
    SET_TRUST_CENTER_DB(state, payload) {
      console.log('Inside SET_TRUST_CENTER_DB', payload)
      state.trustCenterDb = payload
    },
    SET_TRUST_CENTER_SHARES_DB(state, payload) {
      console.log('Inside SET_TRUST_CENTER_SHARES_DB', payload)
      state.trustCenterSharesDb = payload
    },
    SET_SUBSCRIPTIONS(state, payload) {
      console.log('Inside SET_SUBSCRIPTIONS', payload)
      state.subscriptions = payload || []
    },
    SET_UPDATE_ID(state, payload) {
      state.updateId = payload
    },
  },
  getters: {
    GET_TRUST_CENTER_DATA(state) {
      // console.log("Inside GET_TRUST_CENTER_DATA - state.trustCenterData:", state.trustCenterData)
      return state.trustCenterData
    },
    GET_FIREBASE_BINDINGS_RUN(state) {
      return state.firebaseBindingsRun
    },
    GET_TRUST_CENTER_SHARES_DB(state) {
      return state.trustCenterSharesDb
    },
    GET_TRUST_CENTER_DB(state) {
      return state.trustCenterDb
    },
    GET_SUBSCRIPTIONS(state) {
      return state.subscriptions
    },
    GET_UPDATE_ID(state) {
      return state.updateId
    },
    GET_SELF_SERVICE_QUESTIONNAIRES(state) {
      return state.trustCenterSharesDb.filter(
        (item) => item.type === 'selfServiceQuestionnaire' // includes both self-service and send-to-admin questionnaires (according to routeToHuman field)
      )
    },
  },
  actions: {},
}
